module.exports = __webpack_public_path__ + "img/20201129_224006.f8284717.jpg";